import { TriangleAlert } from "lucide-react";
import { IconBox } from "../IconBox";
import type { ConfirmationProps } from "./Confirmation";

export const dangerPreset = {
  icon: <IconBox preset="danger" icon={TriangleAlert} />,
  action: {
    variant: "contained" as const,
    color: "danger" as const,
  },
} satisfies Partial<ConfirmationProps>;

export const warningPreset = {
  icon: <IconBox preset="warning" icon={TriangleAlert} />,
} satisfies Partial<ConfirmationProps>;
